import { Line } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableIndustry from '../../Tables/TableIndustry'
import TableSegmentsMarketShare from '../../Tables/TableSegmentsMarketShare'

const TotalEnduroCard = props => {
  const { totalEnduro = [], selectedDate, totalEnduroSegment, gTotalEnduroA, gTotalEnduroB } = props
  const classes = useStyles()
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Enduro</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableIndustry array={totalEnduro} selectedDate={selectedDate} param="EMPRESA" />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableSegmentsMarketShare
              array={totalEnduroSegment}
              selectedDate={selectedDate}
              enableDate
              sizeHeader={3}
              param="EMPRESA"
              order="SEGMENTO"
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – mes</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gTotalEnduroB, 'EMPRESA', 'PORC', 'MES', '100')}
              options={Utils.optionsLine}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – año</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gTotalEnduroA, 'EMPRESA', 'PORCENTAJE', 'y', '100')}
              options={Utils.optionsLine}
            />{' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalEnduroCard
